import React from 'react';
import PropTypes from 'prop-types';
import { Image, StyleSheet, Text, View } from '@react-pdf/renderer';

const QRCallToActionPdf = ({ callToAction, qrUrl, qrImage }) => {
  const styles = StyleSheet.create({
    callToActionContainer: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      height: '15%',
      paddingLeft: 30,
      paddingRight: 30
    },
    qrCode: {
      height: 60,
      width: 60,
      marginRight: 10
    },
    callToAction: {
      fontWeight: 'bold',
      fontSize: 12
    },
    url: {
      fontSize: 12
    }
  });

  if (!qrUrl || !qrImage) {
    return <View style={styles.callToActionContainer} />;
  }

  return (
    <View style={styles.callToActionContainer}>
      <View>
        <Image src={qrImage} style={styles.qrCode} />
      </View>
      <View>
        <Text style={styles.callToAction}>{callToAction}</Text>
        <Text style={styles.url}>{qrUrl}</Text>
      </View>
    </View>
  );
};

QRCallToActionPdf.propTypes = {
  callToAction: PropTypes.string,
  qrUrl: PropTypes.string,
  qrImage: PropTypes.string
};

export { QRCallToActionPdf };
